export async function deriveTestTagUid(seed: string): Promise<string> {
  const data = new TextEncoder().encode(seed);
  const hash = new Uint8Array(await crypto.subtle.digest('SHA-256', data));
  const bytes = [0x04, ...hash.slice(0, 6)];
  return bytes.map((b) => b.toString(16).padStart(2, '0').toUpperCase()).join(':');
}
